import { render } from "./detail-view.vue?vue&type=template&id=4aec3eb0&ts=true&lang=pug"
import script from "./detail-view.vue?vue&type=script&setup=true&lang=ts"
export * from "./detail-view.vue?vue&type=script&setup=true&lang=ts"

import "./detail-view.vue?vue&type=style&index=0&id=4aec3eb0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__